import { Component, inject, OnInit } from '@angular/core';
import { TreeModelsDialogComponent } from '../tree-models-dialog/tree-models-dialog.component';
import { MAT_DIALOG_DATA, MatDialog, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { CommonModule } from '@angular/common';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { ViewFromServer } from '../../../interfaces/ViewFromServer';
import { ServerResponse } from '../../../interfaces/ServerResponse';
import { UserService } from '../../../services/user.service';
import { ISaveView } from '../../../interfaces/SaveView';
import { SharedService } from '../../../services/shared.service';

@Component({
  selector: 'app-select-view-dialog',
  standalone: true,
  imports: [
    CommonModule,
    MatProgressSpinnerModule,
    MatIconModule,
    MatButtonModule,
    MatDialogModule
  ],
  templateUrl: './select-view-dialog.component.html',
  styleUrl: './select-view-dialog.component.scss'
})
export class SelectViewDialogComponent implements OnInit{

  constructor(private userService: UserService, private sharedService: SharedService){}

  ngOnInit(): void {
    this.getViews();
  }

  private readonly dialogRef = inject(MatDialogRef<TreeModelsDialogComponent>, { optional: true });
  
  readonly dialog = inject(MatDialog);
  
  isLoading: boolean = false;

  views!: ViewFromServer[];

  getViews() {
    this.isLoading = true;
    this.userService.getViews().subscribe({
      next: (res: ServerResponse<ViewFromServer>) => {
        this.views = res.result;
        for (const view of this.views) {
          view.file_content = JSON.parse(view.file_content as string) as ISaveView;
          view.file_content.name_value = view.file_name;
        }
        this.isLoading = false;
      },
      error: (error) => {
        this.isLoading = false;
      }
    });
  }

  getViewServiceName(view: ViewFromServer): string{
    let id = (view.file_content as ISaveView).data_service_id;
    let dataservice = this.sharedService.data_services!.find((service)=>service.data_service_id === id);
    return (dataservice) ? dataservice?.data_service_name : "";
  }

  onSelectView(view: ViewFromServer){
    this.dialogRef?.close(view);
  }

  onCancel() {
    this.dialogRef?.close();
  }
}
